import { currentDomain, isPortalDomain } from './currentDomain'

const getChargeAmpsApiPath = (): string => {
    if (isPortalDomain && currentDomain) {
        return `/${currentDomain}/api`
    }

    if (location.hostname === 'localhost' && process.env.API_SERVER) {
        return process.env.API_SERVER
    }

    return '/api'
}

export default getChargeAmpsApiPath
